import {FaCompass} from 'react-icons/fa'

export default function Loader() {
  return <FaCompass className='h-6 w-6 animate-spin text-2xl text-slate-500' />
}
